import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import moment from "moment";
import 'moment/locale/fr'
moment.locale("fr");

const palette = {
    primary: {
        main: "#33838b",
    },
    secondary: {
        main: "#7cd28b",
        light: "#e6f4f1",
    },
};

const outerTheme = createTheme({
    palette: palette,
    typography: {
        fontFamily: "FreightSansPro",
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
          @font-face {
            font-family: 'FreightSansPro';
            src: local('FreightSansPro'), url(./fonts/FreightSansProMedium-Regular.woff) format('woff');
          }`,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ThemeProvider theme={outerTheme}>
        <ToastContainer position="bottom-right" autoClose={5000} />
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
